import React from 'react'
import { Flex, Link, Input } from '@fareye/ui'
import { FaCopy, FaEnvelope } from '@fareye/utils'

function CopyText(props: any) {
  const { link, dataTestid } = props
  const [select, setSelect] = React.useState(false)
  async function copy() {
    try {
      await (window.navigator as any).share({
        title: 'Share trip',
        url: link
      })
    } catch (error) {
      console.error('webshare not working')
      let doc: any = document
      let win: any = window
      const elem: any = doc.querySelector(`[data-testid=${dataTestid}]`)
      elem.select()
      doc.execCommand('copy')
      setSelect(true)
      alert('Your url is copied!')
      if (win.getSelection) {
        win.getSelection().removeAllRanges()
      } else if (doc.selection) {
        doc.selection.empty()
      }
    }
  }

  return (
    <Flex alignItemsCenter>
      <div style={{ flex: 1, display: 'flex' }}>
        <Input
          style={{
            boxSizing: 'border-box',
            border: '0px solid transparent',
            userSelect: 'none',
            width: '100%',
            color: '#217CE7',
            '&:hover': {
              border: '0px solid transparent'
            },
            '&:focus': {
              border: '0px solid transparent'
            }
          }}
          data-testid={dataTestid}
          variant="m"
          defaultValue={link}
        />
        <Link
          style={{
            opacity: 0,
            position: 'absolute',
            top: 0,
            padding: 0
          }}
          color={'primary'}
          target="_blank"
          to={link ? link : ''}
        >
          {link}
        </Link>
      </div>
      <div>
        <FaCopy
          color={select ? '#fff' : '#217CE7'}
          style={{
            borderRadius: 3,
            padding: '2px 2px 3px 3px',
            background: select ? '#217CE7' : '#fff',
            cursor: 'pointer',
            marginRight: '5px'
          }}
          onClick={() => copy()}
        />
        <a href={`mailto:john@example.com?subject=Check ${link}`}>
          <FaEnvelope />
        </a>
      </div>
    </Flex>
  )
}

export default CopyText
